import { createEnquiryLogic } from './createEnquiryLogic';
import { createCallbackRequestLogic } from './createCallbackRequestLogic';

export const logic = [createEnquiryLogic, createCallbackRequestLogic];
